import { ReactNode, useRef } from 'react';

import { useOnClickOutside } from 'hooks/useOnClickOutside';

type Props = {
  children: ReactNode;
  onClickOutside: (event: TouchEvent | MouseEvent) => void;
};

export function ClickOutside({ children, onClickOutside }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  useOnClickOutside({ containerRef, onClickOutside });

  return <div ref={containerRef}>{children}</div>;
}
